import { Route, Routes } from "react-router-dom"
import RoleList from "./components/RoleList"

export default function AdminRolesPage() {
  return (
    <Routes>
      <Route index element={<RoleList />} />
    </Routes>
  )
}
